import React, { useState, useEffect } from 'react';
import { FaClock, FaCalendarAlt } from 'react-icons/fa';
import './DateTime.css';

function DateTime() {
    const [time, setTime] = useState('');
    const [date, setDate] = useState('');
    const [tz, setTz] = useState('');

    useEffect(() => {
        const update = () => {
            const now = new Date();
            let h = now.getHours();
            const m = String(now.getMinutes()).padStart(2, '0');
            const s = String(now.getSeconds()).padStart(2, '0');
            const ampm = h >= 12 ? 'PM' : 'AM';
            h = h % 12 || 12;
            setTime(`${String(h).padStart(2, '0')}:${m}:${s} ${ampm}`);
            const day = String(now.getDate()).padStart(2, '0');
            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            setDate(`${day} ${months[now.getMonth()]} ${now.getFullYear()}`);
            const offset = -now.getTimezoneOffset() / 60;
            setTz(`UTC${offset >= 0 ? '+' : ''}${offset}`);
        };
        update();
        const interval = setInterval(update, 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="datetime-container">
            <div className="datetime-top">
                <div className="datetime-header"><FaClock size={14} color="#888" /> <span>system.time</span></div>
                <div className="time-display">{time}</div>
            </div>
            <div className="date-display"><FaCalendarAlt size={12} style={{marginRight: '6px'}} /> {date}<span className="tz-label">{tz}</span></div>
        </div>
    );
}
export default DateTime;